<template>
  <div
    class="tw:overflow-x-auto tw:overflow-y-hidden"
    :class="{ 'tw:min-h-14': size === 'md', 'tw:min-h-10': size === 'sm' }"
  >
    <div class="tw:flex tw:flex-nowrap tw:w-full tw:min-w-fit">
      <div
        v-for="tab in tabs"
        :key="tab.value"
        class="tw:inline-flex tw:flex-1 tw:justify-center tw:items-center tw:p-2 tw:outline tw:outline-[#1E353E] tw:min-w-fit tw:font-semibold tw:text-white tw:text-base tw:sm:text-xl tw:text-center tw:leading-none tw:cursor-pointer"
        :class="{
          'tw:bg-gradient-to-b tw:from-[#0083AD] tw:to-[#00354F]': selectedTab === tab.value,
          'tw:bg-gradient-to-tl tw:from-[#040F14] tw:to-[#081B25]': selectedTab !== tab.value,
          'tw:h-10': size === 'sm',
          'tw:h-14': size === 'md'
        }"
        @click="selectedTab = tab.value"
      >
        {{ tab.label }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Tab {
  label: string;
  value: string;
}

const { tabs, size = 'md' } = defineProps<{
  tabs: Tab[];
  size?: 'sm' | 'md';
}>();

const selectedTab = defineModel<string>({ required: true });
</script>

<style scope lang="scss">
.tabs {
  min-height: 56px;
  overflow-y: hidden;
}
</style>
